import React, {Component} from 'react';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxCallHelper from "../../../../store/actionreducers/callHelper";
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import _ from 'lodash';
import {constDataDialogs} from "../../../../constants";
import {
    Dialog,
    DialogContent,
    FormControl,
    InputLabel,
    Input,
    Icon,
    IconButton,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    Avatar,
    Tooltip
} from '@material-ui/core';
import {UecareDropdown} from "../../../../components";


const initNewMedicalState = {
    id: '',
    hospital: {},
    user: {
        id: '',
        family_name: '',
        given_name: '',
        name: '',
        nickname: '',
        email: '',
        cell_phone_no: '',
        birthday: '',
        avatar: {url: 'https://res.cloudinary.com/uecare/image/upload/v1531703417/DefaultImage/medicalHead_3x.png'},
    }
};

const initControllerState = {
    is_show_map: false,
    zoom: 11,
    city: {id: 0}, // 醫生執業縣市
    institution: {city: {id: 0}, lat: null, lng: null,} // 醫生工作醫院
};

class MedicalDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {medical: initNewMedicalState, ...initControllerState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * no vipDialog , no data need to resolve
         */
        if (!this.props.medicalDialog) return;

        /**
         * After Dialog Open
         */
        if (!prevProps.medicalDialog || (!prevProps.medicalDialog.props.open && this.props.medicalDialog.props.open)) {

            /**
             * Dialog type: 'edit'
             * Update State
             */
            if (this.props.medicalDialog.type === 'edit' &&
                this.props.medical &&
                !_.isEqual(this.props.medical, prevState.medical)) {

                const institution = this.props.medical.institution || initControllerState.institution;
                const city = this.props.medical.city || initControllerState.city;
                this.setState({medical: this.props.medical, ...initControllerState, institution, city});
            }

            /**
             * Dialog type: 'new'
             * Update State
             */
            if (this.props.medicalDialog.type === 'new') {
                _.set(initNewMedicalState, 'user.name', initNewMedicalState.user.family_name + initNewMedicalState.user.given_name);
                this.setState({medical: initNewMedicalState, ...initControllerState});
            }
        }
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.medicalDialog});
    };

    _getLat() {
        return (this.state.institution && this.state.institution.lat) || (this.state.medical.hospital && this.state.medical.hospital.lat) || 0;
    }

    _getLng() {
        return (this.state.institution && this.state.institution.lng) || (this.state.medical.hospital && this.state.medical.hospital.lng) || 0;
    }

    _updateCity(city) {
        this.setState({city, institution: {...this.state.institution, city}});
    }

    canBeSubmitted() {
        return this.state.user.name.length > 0;
    }

    render() {

        const {classes, cities, medicalDialog, validateMedical, enableMedical} = this.props;
        const {getMedicals, openLoadingMask, closeLoadingMask} = this.props;

        if (!medicalDialog || medicalDialog.props.open === false) return <div/>;

        return (
            <Dialog className={classes.root} {...medicalDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {medicalDialog.type === 'new' ? '新的醫師資料' : '醫師資料'}
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <Avatar className="w-96 h-96" alt="contact avatar" src={this.state.medical.user.avatar.url}/>
                        {medicalDialog.type === 'edit' && (
                            <Typography variant="title" color="inherit" className="pt-8">
                                {this.state.medical.user.name}
                            </Typography>
                        )}
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <UecareDropdown
                        label='執業縣市'
                        icon='place'
                        name='work_city'
                        id='work_city'
                        className={classes.formControl}
                        value={this.state.institution.city.id}
                        options={cities}
                        onChange={(event, selectedOption) => {
                            this._updateCity(selectedOption);
                            // this.setState({city: selectedOption});
                        }}/>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">domain</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="cell_phone_no">服務機構名稱</InputLabel>
                            <Input id="cell_phone_no" name="cell_phone_no"
                                   value={(this.state.medical.hospital) ? this.state.medical.hospital.name : this.state.medical.unvalidated_hospital_name}
                                   onChange={(event) => {
                                       const hospitalName = event.target.value;
                                       this.setState({institution: {...this.state.institution, name: hospitalName}});
                                   }}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20"/>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="address">服務機構地址</InputLabel>
                            <Input id="address" name="address" value={this.state.address}
                                   onChange={(event) => {
                                       const hospitalAddress = event.target.value;
                                       this.setState({
                                           institution: {
                                               ...this.state.institution,
                                               address: hospitalAddress
                                           }
                                       });
                                   }}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">email</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="email">醫師證號</InputLabel>
                            <Input id="email" name="email" value={this.state.medical.certificate_no}/>
                        </FormControl>
                    </div>

                    {
                        (false) ?
                            ''
                            :
                            <DialogActions className="justify-between">
                                <Tooltip title="驗證成功">
                                    <IconButton
                                        onClick={async () => {
                                            try {
                                                openLoadingMask();

                                                console.log('institution=', this.state.institution);

                                                // 驗證資料 & 設定醫院位置
                                                await validateMedical({
                                                    medicalId: this.state.medical.id,
                                                    institution: this.state.institution,
                                                    validateFail: false
                                                });

                                                await getMedicals();
                                                closeLoadingMask();
                                                this.closeDataDialog();
                                            } catch (e) {
                                                console.warn('you got an error = ', e);
                                            }
                                        }}
                                    >
                                        <Icon>spellcheck</Icon>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="驗證失敗">
                                    <IconButton
                                        onClick={async () => {
                                            try {
                                                openLoadingMask();

                                                // 驗證資料 , 資料有誤
                                                await validateMedical({
                                                    medicalId: this.state.medical.id,
                                                    validateFail: true
                                                });

                                                await getMedicals();
                                                closeLoadingMask();
                                                this.closeDataDialog();
                                            } catch (e) {
                                                console.warn('you got an error = ', e);
                                            }
                                        }}
                                    >
                                        <Icon>error</Icon>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="直接開通">
                                    <IconButton
                                        onClick={async () => {
                                            try {
                                                openLoadingMask();

                                                // 直接開通
                                                await enableMedical(this.state.medical.id);

                                                await getMedicals();
                                                closeLoadingMask();
                                                this.closeDataDialog();
                                            } catch (e) {
                                                console.warn('you got an error = ', e);
                                            }
                                        }}
                                    >
                                        <Icon>how_to_reg</Icon>
                                    </IconButton>
                                </Tooltip>
                            </DialogActions>
                    }


                </DialogContent>


            </Dialog>
        );
    }
}

const styles = theme => ({
    root: {},
    formControl: {
        marginBottom: 24
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        validateMedical: ReduxCallHelper.ActionCreator.validateMedical,
        enableMedical: ReduxCallHelper.ActionCreator.enableMedical,
        getMedicals: ReduxCallHelper.ActionCreator.getMedicals,
    }, dispatch);
}

function mapStateToProps({global: {dataDialog, dataDialogs}, city: {cities}, callHelper: {medical}}) {

    return {
        medicalDialog: dataDialogs[constDataDialogs.name.medicalDialog],
        dataDialog,
        medical,
        cities,
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(MedicalDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/medical/MedicalDialog.js